var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23005 2.20828C2.35118 1.8722 2.67461 1.62904 3.05011 1.62904H15.0501C15.4256 1.62904 15.749 1.87214 15.8701 2.20814L9.04999 6.98223L2.23005 2.20828ZM0.921075 2.51442V11.5C0.921075 12.6724 1.8777 13.629 3.05011 13.629H15.0501C16.2225 13.629 17.1791 12.6724 17.1791 11.5V2.50001C17.1791 1.3276 16.2225 0.370972 15.0501 0.370972H3.05011C1.88384 0.370972 0.931103 1.3176 0.921153 2.4816C0.920842 2.49255 0.920816 2.50349 0.921075 2.51442ZM2.17914 3.70831L8.68926 8.26539C8.90585 8.417 9.19412 8.417 9.41071 8.26539L15.9211 3.70814V11.5C15.9211 11.9776 15.5277 12.371 15.0501 12.371H3.05011C2.57251 12.371 2.17914 11.9776 2.17914 11.5V3.70831Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.33b8dc91dec2e774117ef3436824629e.svg";
export { ForwardRef as ReactComponent };